export const INITIALISE_MY_PARKD = 'INITIALISE_MY_PARKD';


export const initialiseMyParkd = () => {
    return {
        type: INITIALISE_MY_PARKD,
        payload: {},
    };
};
